import { useContext } from '@nuxtjs/composition-api';

export function useRouter() {
  const { app } = useContext();

  return app.router;
}
